import styled from "styled-components";

export const ContainerSegmented = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background: #F5F5F5;
    border: thin solid var(--border-color);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 2px;
    position: relative;
    flex-shrink: 0;

    button.ContainerSegmented__item {
        border: none;
        background: transparent;
        border-radius: 6px;
        box-sizing: border-box;
        padding: 4px 10px;
        cursor: pointer;
        font-size: 11px;
        font-weight: 500;
        color: var(--text-color-light);
        white-space: nowrap;
        transition: color 0.3s;
        position: relative;
        z-index: 1;

        :hover:not([data-active = true]):not(:disabled) {
            color: var(--text-color);
        }

        :disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }

        :is([data-active = true]) {
            color: #fff;
            font-weight: 600;
        }
    }

    div.ContainerSegmented__highlight {
        position: absolute;
        top: 2px;
        bottom: 2px;
        border-radius: 6px;
        background: var(--primary-color);
        z-index: 0;
    }
`;
